/**
 * Portal Manta · detectarFormatoJSON
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { extKm } from '../../globals.js';

function detectarFormatoJSON(obj){
  if (!obj || typeof obj !== 'object') return 'invalido';
  // Formato Manta nativo: tem mef_combinado OU combinado.obras
  if (obj.mef_combinado || (obj.combinado && obj.combinado.obras)) return 'manta-completo';
  // Formato lotes_info / orcamento_antt: dados de múltiplos lotes
  if (Array.isArray(obj) && obj[0] && (obj[0].sigla || obj[0].lote || obj[0].sig)) return 'manta-lotes-array';
  // Formato raso (extKm direto na raiz)
  if ('extKm' in obj || 'ext_km' in obj || 'extensao' in obj) return 'raso';
  // Formato KPIs aninhados (qual + kpis)
  if (obj.qual || obj.kpis) return 'portal-v26';
  return 'desconhecido';
}

export { detectarFormatoJSON };
export default detectarFormatoJSON;
